export enum MKAdaptationLogicType {
    /**
     * Default adaptation logic.
     *
     * It uses a hybrid approach that builds on top of the buffer-based rules where the buffer-based logic that considers fill state and fill rate to make quality decisions
     * and adds a prediction algorithm that estimates the download time of segments. Downloads that exceed the expected download time, may be cancelled to prevent stalls.
     */
    DOWNLOAD_PREDICTION = "v3",

    /**
     * Adaptation logic tailored to low-latency streaming of chunked CMAF live content.
     *
     * Should only ever be used in combination with {@link MKTweaksConfig.chunked_cmaf_streaming}.
     */
    LOW_LATENCY = "low-latency-v1",

    /**
     * Based on the paper: M. Nguyen [et al.], "WISH: User-centric Bitrate Adaptation for HTTP Adaptive Streaming on
     * Mobile Devices," @see {@link https://dx.doi.org/10.1109/MMSP53017.2021.9733605}.
     *
     * WISH employs a Weighted Sum model to achieve high QoE for video streaming, while allowing to express preferences
     * that allow to trade off data usage, stall events, and video quality. @see {@link MKTweaksConfig.wish_abr_params}
     */
    WISH = "wish"
}